export const UPDATE_SELLER = 'UPDATE_SELLER';
export const RESET_SELLER = 'RESET_SELLER';